export default __webpack_public_path__ + "static/media/metaMagnet.699fff4d.svg";